/* ==========================================================================
   Product Spotlight — accordion binding.
   The specs reuse the PDP accordion markup. initProductAccordions() runs
   globally on load (live pages); here we only rebind on shopify:section:load
   so the accordion works after edits in the theme editor.
   ========================================================================== */
(function () {
  document.addEventListener('shopify:section:load', (event) => {
    if (
      typeof window.initProductAccordions === 'function' &&
      event.target.querySelector('.product-accordion-group')
    ) {
      window.initProductAccordions(event.target);
    }
  });
})();
